import { Component, EventEmitter, Input, OnInit, Optional, Output } from "@angular/core";
import { FormBuilder, ControlContainer, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  BaseFpxComponentState,
  BaseFpxDataService,
  BaseFpxFormComponent,
  BaseFpxFormHelper,
} from "@fpx/core";
import { Observable, of } from "rxjs";
import {
  FpxDynamicFormHelper,
  FpxDynamicFormState,
} from "./fpx-dynamic-form.helper";

@Component({
  selector: "fpx-dynamic-form",
  templateUrl: "./fpx-dynamic-form.component.html",
  styleUrls: ["./fpx-dynamic-form.component.scss"],
  providers: [FpxDynamicFormHelper],
})
export class FpxDynamicFormComponent extends BaseFpxFormComponent<
  FpxDynamicFormHelper,
  FpxDynamicFormState
> {
  protected formConfig: Array<DynamicFormConfig> = [];
  @Input() formDataService: BaseFpxDataService<any>;
  @Input() formHelper: BaseFpxFormHelper<BaseFpxComponentState>;
  @Input() formControlService: Map<string, BaseFpxDataService<any>> = new Map<
    string,
    BaseFpxDataService<any>
  >();
  @Input() formgroupName: string;
  @Output() setFormGroup : EventEmitter<any> = new EventEmitter<any>();

  controllovs: Map<string, Observable<any>> = new Map<
    string,
    Observable<any>
  >();
  constructor(
    _formBuilder: FormBuilder,
    _route: Router,
    @Optional() _controlContainer: ControlContainer,
    _helper: FpxDynamicFormHelper
  ) {
    super(_formBuilder, _route, _controlContainer, _helper);
  }



  protected async doPreInit() {
    await this.formDataService
      .loadForm?.(this.routingKey)().toPromise().then(
        (res) => {
          console.log(res);
          this.formConfig = res;
          this.formConfig.forEach((control) => {
            let validators = [];
            if (control.required) {
              validators.push(Validators.required);
            }
            if (control.pattern) {
              validators.push(Validators.pattern(control.pattern));
            }
            if (control.maxLength && control.fieldType === "textBox") {
              validators.push(Validators.maxLength(control.maxLength));
            } else if (control.maxLength && control.fieldType === "numeric") {
              validators.push(Validators.max(control.maxLength));
            }
            if (control.minLength && control.fieldType === "textBox") {
              validators.push(Validators.minLength(control.minLength));
            } else if (control.maxLength && control.fieldType === "numeric") {
              validators.push(Validators.min(control.minLength));
            }
            if (
              control.lov &&
              (control.fieldType === "comboBox" ||
                control.fieldType === "radioButton")
            ) {
              this.controllovs.set(
                `${this.formgroupName}${control.formControlName}`,
                of(control.lov)
              );
            } else if (
              control.serviceName &&
              (control.fieldType === "comboBox" ||
                control.fieldType === "radioButton")
            ) {
              if (this.formControlService.has(control.formControlName)) {
                const service = this.formControlService.get(control.formControlName);
                this.controllovs.set(
                  `${this.formgroupName}${control.formControlName}`,
                  service.lookup(null)()
                );
              }
            }
            this.addFormControl(
              control.formControlName,
              control.defaultValue || "",
              validators
            );
          });
        })

    if (this.formDataService) {
      this.setDataService(this.formDataService);
    }
    if (this.formHelper) {
      this.setHelper(this.formHelper);
    }
  }

  protected doPostInit(): void {
    this.setFormGroup.emit(this.formGroup);
  }

  protected getService(formControlName: string): Observable<any> {
    return this.controllovs.has(`${this.formgroupName}${formControlName}`)
      ? this.controllovs.get(`${this.formgroupName}${formControlName}`)
      : of([]);
  }
}

export interface DynamicFormConfig {
  formControlName: string;
  fieldType:
    | "textBox"
    | "comboBox"
    | "checkbox"
    | "radioButton"
    | "date"
    | "numeric";
  defaultValue: any;
  minLength: number;
  maxLength: number;
  required: boolean;
  pattern: string;
  label: string;
  placeHolder: string;
  hint: string;
  lov: Array<any>;
  serviceName: string;
}
